const centura_webshop = window.centura_webshop || {};
window.centura_webshop = centura_webshop;

if (!frappe._messages) frappe._messages = {};
if (frappe.boot && frappe.boot.webshop_translations) {
    Object.assign(frappe._messages, frappe.boot.webshop_translations);
}

const ICON_GRID = `<svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor">
	<rect x="0" y="0" width="5.5" height="5.5" rx="0.5"/>
	<rect x="8.5" y="0" width="5.5" height="5.5" rx="0.5"/>
	<rect x="0" y="8.5" width="5.5" height="5.5" rx="0.5"/>
	<rect x="8.5" y="8.5" width="5.5" height="5.5" rx="0.5"/>
</svg>`;

const ICON_LIST = `<svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor">
	<rect x="0" y="1" width="14" height="2.5" rx="0.5"/>
	<rect x="0" y="5.75" width="14" height="2.5" rx="0.5"/>
	<rect x="0" y="10.5" width="14" height="2.5" rx="0.5"/>
</svg>`;

const ICON_SEARCH = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
	<circle cx="11" cy="11" r="7"/>
	<path d="M20 20l-3.5-3.5"/>
</svg>`;

centura_webshop.ProductBrowser = class ProductBrowser {
    constructor(wrapper, options = {}) {
        this.wrapper = $(wrapper);
        const storedView = localStorage.getItem('ew_product_view');
        const validView = ['grid', 'list'].includes(storedView)
            ? storedView
            : 'grid';
        this.options = Object.assign(
            {
                page_length: 12,
                view: validView,
                item_group: null
            },
            options
        );

        this.start = 0;
        this.show_stock = false;
        this.show_stock_qty = false;
        this.show_planned_qty = false;
        this.show_price = false;
        this.show_customer_filter = false;
        this.filters = this._parse_url_filters();
        this.layout = this.wrapper.closest('.webshop-layout');
        this.init();
    }

    init() {
        this.render_skeleton();
        (frappe._translations_loaded || Promise.resolve()).then(() => {
            this.render_controls();
            this.fetch_products();
        });
        this.bind_events();
    }

    render_controls() {
        this.wrapper.find('.webshop-controls').html(`
			<div class="d-flex align-items-center gap-2">
				<span class="webshop-result-count text-muted"></span>
			</div>
			<div class="d-flex align-items-center gap-3">
			<div class="webshop-view-toggle">
				<button class="webshop-view-btn ${this.options.view === 'grid' ? 'active' : ''}"
					data-view="grid" title="${__('Grid View')}">
					${ICON_GRID}
				</button>
				<button class="webshop-view-btn ${this.options.view === 'list' ? 'active' : ''}"
					data-view="list" title="${__('List View')}">
					${ICON_LIST}
				</button>
			</div>
			</div>
		`);
    }

    render_skeleton() {
        const container_class =
            this.options.view === 'grid'
                ? 'webshop-products-grid'
                : 'webshop-products-list';
        let html = `<div class="${container_class}">`;
        for (let i = 0; i < this.options.page_length; i++) {
            html += `
				<div class="webshop-product-card webshop-skeleton-card">
					<div class="skeleton webshop-skeleton-image"></div>
					<div class="skeleton webshop-skeleton-text"></div>
					<div class="skeleton webshop-skeleton-price"></div>
				</div>
			`;
        }
        html += '</div>';
        this.wrapper.find('.products-area').html(html);
    }

    fetch_products() {
        frappe.call({
            method: 'centura_webshop.api.get_product_filter_data',
            args: {
                query_args: {
                    field_filters: this.filters.field_filters || {},
                    item_group: this.options.item_group,
                    start: this.start,
                    search: this.filters.search || '',
                    sort_by: 'ranking',
                    sort_order: 'desc',
                    price_range: this.filters.price_range || null,
                    stock_filter: this.filters.stock_filter || null,
                    customer_filter: this.filters.customer_filter || null
                }
            },
            callback: (r) => {
                if (r.message) {
                    this.show_stock = r.message.show_stock || false;
                    this.show_stock_qty = r.message.show_stock_qty || false;
                    this.show_planned_qty = r.message.show_planned_qty || false;
                    this.show_price = r.message.show_price || false;
                    this.show_item_code = r.message.show_item_code || false;
                    this.enable_favorites = r.message.enable_favorites || false;
                    this.show_customer_filter =
                        r.message.show_customer_filter || false;
                    this.render_products(r.message.items || []);
                    centura_webshop.cart._sync_card_indicators();
                    this.render_filters(r.message.filters || {});
                    this.render_pagination(r.message.items_count || 0);
                    this.wrapper
                        .find('.webshop-result-count')
                        .text(
                            __('{0} products found', [
                                r.message.items_count || 0
                            ])
                        );
                }
            }
        });
    }

    render_products(items) {
        if (!items.length) {
            this.wrapper.find('.products-area').html(`
				<div class="webshop-cart-empty">
					<div class="webshop-cart-empty__icon">${ICON_SEARCH}</div>
					<span class="webshop-cart-empty__title">${__('No products found')}</span>
					<span class="webshop-cart-empty__text">${__(
                        'Try adjusting your filters or search terms.'
                    )}</span>
					<a href="/shop/products" class="webshop-cart-empty__action">${__(
                        'Browse All Products'
                    )}</a>
				</div>
			`);
            return;
        }

        const container_class =
            this.options.view === 'grid'
                ? 'webshop-products-grid'
                : 'webshop-products-list';
        const cards = items.map((item) => this._render_card(item)).join('');
        this.wrapper
            .find('.products-area')
            .html(`<div class="${container_class}">${cards}</div>`);
    }

    _render_card(item) {
        const image_src = item.website_image || item.image || '';
        const escaped_item_code = frappe.utils.escape_html(item.item_code);
        const escaped_route = frappe.utils.escape_html(item.route);
        const is_guest = frappe.session.user === 'Guest';
        const user_favs = centura_webshop.cart._user_favorites || [];
        const is_fav = user_favs.includes(item.item_code);
        const fav_html =
            !is_guest && this.enable_favorites
                ? `<button class="webshop-btn-favorite${
                      is_fav ? ' active' : ''
                  }"
			data-item-code="${escaped_item_code}"
			title="${is_fav ? __('Remove from Favorites') : __('Add to Favorites')}">${
                is_fav ? '\u2665' : '\u2661'
            }</button>`
                : '';

        const image_html = `<a href="/${escaped_route}" class="webshop-product-image-wrapper">
			${
                image_src
                    ? `<img src="${frappe.utils.escape_html(
                          image_src
                      )}" alt="${frappe.utils.escape_html(
                          item.web_item_name
                      )}" loading="lazy">`
                    : `<div class="webshop-product-image-placeholder"></div>`
            }
			<span class="webshop-cart-qty-badge" style="display:none"></span>
			${fav_html}
		</a>`;

        const price_html = item.formatted_price
            ? `<span class="webshop-product-price">${frappe.utils.escape_html(
                  item.formatted_price
              )}${
                  item.formatted_mrp
                      ? `<span class="webshop-original-price">${frappe.utils.escape_html(
                            item.formatted_mrp
                        )}</span>`
                      : ''
              }${
                  item.discount
                      ? `<span class="webshop-discount-badge">${frappe.utils.escape_html(
                            item.discount
                        )} ${__('OFF')}</span>`
                      : ''
              }</span>`
            : '';

        const stock_html = this.show_stock
            ? (() => {
                  const stock_class = item.in_stock
                      ? 'in-stock'
                      : 'out-of-stock';
                  const stock_text = item.in_stock
                      ? __('In Stock')
                      : __('Out of Stock');
                  const qty_text =
                      this.show_stock_qty && item.stock_qty > 0
                          ? ` (${Math.floor(item.stock_qty)})`
                          : '';
                  const planned_text =
                      this.show_planned_qty && item.planned_qty > 0
                          ? `<span class="webshop-product-planned-qty">${__(
                                'In Production'
                            )}: ${Math.floor(item.planned_qty)}</span>`
                          : '';
                  return `<span class="webshop-product-stock ${stock_class}">${stock_text}${qty_text}</span>${planned_text}`;
              })()
            : '';

        const max_qty = item.max_order_qty ?? 9999;
        const can_add = max_qty > 0;

        return `
			<div class="webshop-product-card" data-item-code="${escaped_item_code}">
				${image_html}
				<div class="webshop-product-info">
					<a href="/${escaped_route}" class="webshop-product-title">${frappe.utils.escape_html(
                        item.web_item_name
                    )}</a>
					<span class="webshop-product-category">${frappe.utils.escape_html(
                        item.item_group || ''
                    )}</span>
					${
                        this.show_item_code
                            ? `<span class="webshop-product-item-code">${escaped_item_code}</span>`
                            : ''
                    }
                    ${
                        item.short_description
                            ? `<div class="webshop-product-short-desc">${item.short_description}</div>`
                            : ''
                    }
				</div>
				<div class="webshop-product-actions">
					${stock_html}
					${price_html}
					${
                        is_guest
                            ? ''
                            : can_add
                              ? `
					<div class="webshop-card-qty-control">
						<button class="webshop-qty-btn webshop-card-qty-minus" type="button">&#8722;</button>
						<input type="number" class="webshop-card-qty-input" value="1" min="1"
							max="${max_qty}" data-item-code="${escaped_item_code}">
						<button class="webshop-qty-btn webshop-card-qty-plus" type="button">&#43;</button>
					</div>
					<button class="btn webshop-btn-add-to-cart" data-item-code="${escaped_item_code}">
						${__('Add to Cart')}
					</button>
					`
                              : `
					<button class="btn webshop-btn-add-to-cart" disabled>
						${__('Out of Stock')}
					</button>
					`
                    }
				</div>
			</div>
		`;
    }

    render_filters(filters) {
        this.wrapper.trigger('filters-loaded', [
            filters,
            this.show_price,
            this.show_stock,
            this.filters.stock_filter,
            this.show_customer_filter,
            this.filters.customer_filter
        ]);
    }

    render_pagination(total) {
        const total_pages = Math.ceil(total / this.options.page_length);
        const current_page =
            Math.floor(this.start / this.options.page_length) + 1;

        if (total_pages <= 1) {
            this.wrapper.find('.webshop-pagination').html('');
            return;
        }

        let html = '';
        html += `<button class="btn btn-default btn-sm webshop-btn-prev"
			${current_page <= 1 ? 'disabled' : ''}>${__('Previous')}</button>`;
        html += `<span class="text-muted">${__('Page {0} of {1}', [
            current_page,
            total_pages
        ])}</span>`;
        html += `<button class="btn btn-default btn-sm webshop-btn-next"
			${current_page >= total_pages ? 'disabled' : ''}>${__('Next')}</button>`;

        this.wrapper.find('.webshop-pagination').html(html);
    }

    bind_events() {
        this.wrapper.on('click', '.webshop-view-btn', (e) => {
            const view = $(e.currentTarget).data('view');
            this.options.view = view;
            localStorage.setItem('ew_product_view', view);
            this.wrapper.find('.webshop-view-btn').removeClass('active');
            $(e.currentTarget).addClass('active');
            this.fetch_products();
        });

        this.wrapper.on('click', '.webshop-btn-prev', () => {
            this.start = Math.max(0, this.start - this.options.page_length);
            this._update_url();
            this.fetch_products();
        });

        this.wrapper.on('click', '.webshop-btn-next', () => {
            this.start += this.options.page_length;
            this._update_url();
            this.fetch_products();
        });

        this.layout.on(
            'change',
            '.webshop-filter-option input, .webshop-stock-filter, .webshop-customer-filter',
            (e) => {
                const $target = $(e.currentTarget);
                if (
                    $target.hasClass('webshop-stock-filter') &&
                    $target.is(':checked')
                ) {
                    this.layout
                        .find('.webshop-stock-filter')
                        .not($target)
                        .prop('checked', false);
                }
                if (
                    $target.hasClass('webshop-customer-filter') &&
                    $target.is(':checked')
                ) {
                    this.layout
                        .find('.webshop-customer-filter')
                        .not($target)
                        .prop('checked', false);
                }
                this.start = 0;
                this._collect_filters();
                this._update_url();
                this.fetch_products();
            }
        );

        let price_debounce;
        this.layout.on('input', '.webshop-price-range input', () => {
            clearTimeout(price_debounce);
            price_debounce = setTimeout(() => {
                this.start = 0;
                this._collect_filters();
                this._update_url();
                this.fetch_products();
            }, 500);
        });
    }

    _collect_filters() {
        const field_filters = {};

        this.layout
            .find('.webshop-filter-option input:checked')
            .not('.webshop-stock-filter')
            .each(function () {
                const filter_name = $(this).data('filter-name');
                const filter_value = $(this).data('filter-value');
                if (!filter_name || filter_value === undefined) {
                    return;
                }

                if (!field_filters[filter_name]) {
                    field_filters[filter_name] = [];
                }
                field_filters[filter_name].push(filter_value);
            });

        const price_min = this.layout.find('.price-min').val();
        const price_max = this.layout.find('.price-max').val();
        const stock_filter = this.layout
            .find('.webshop-in-stock-filter')
            .is(':checked')
            ? 'in_stock'
            : this.layout.find('.webshop-out-of-stock-filter').is(':checked')
              ? 'out_of_stock'
              : null;
        const customer_filter = this.layout
            .find('.webshop-own-items-filter')
            .is(':checked')
            ? 'own'
            : this.layout.find('.webshop-general-items-filter').is(':checked')
              ? 'general'
              : null;

        this.filters = {
            field_filters,
            search: this.filters.search || '',
            price_range:
                price_min || price_max
                    ? { min: price_min, max: price_max }
                    : null,
            stock_filter,
            customer_filter
        };
    }

    _parse_url_filters() {
        const params = new URLSearchParams(window.location.search);
        const safe_parse = (str, fallback) => {
            try {
                return JSON.parse(str);
            } catch {
                return fallback;
            }
        };
        const raw_customer_filter = params.get('customer_filter');
        return {
            field_filters: safe_parse(params.get('field_filters'), {}),
            search: params.get('search') || '',
            price_range: params.get('price_range')
                ? safe_parse(params.get('price_range'), null)
                : null,
            stock_filter:
                params.get('stock_filter') ||
                (params.get('in_stock') === '1' ? 'in_stock' : null),
            customer_filter:
                raw_customer_filter === 'own' ||
                raw_customer_filter === 'general'
                    ? raw_customer_filter
                    : null
        };
    }

    _update_url() {
        const params = new URLSearchParams();
        if (this.start) params.set('start', this.start);
        if (Object.keys(this.filters.field_filters || {}).length) {
            params.set(
                'field_filters',
                JSON.stringify(this.filters.field_filters)
            );
        }
        if (this.filters.search) params.set('search', this.filters.search);
        if (this.filters.price_range)
            params.set('price_range', JSON.stringify(this.filters.price_range));
        if (this.filters.stock_filter) {
            params.set('stock_filter', this.filters.stock_filter);
        }
        if (this.filters.customer_filter) {
            params.set('customer_filter', this.filters.customer_filter);
        }

        const url = `${window.location.pathname}${
            params.toString() ? '?' + params.toString() : ''
        }`;
        window.history.pushState({}, '', url);
    }
};
